<div>
    <mat-select SelectUi [formControl]="control" (change)="selectDeptt($event.target.value)">
        <mat-option *ngFor="let d of dept.items" [value]="d.id">{{d.name}}</mat-option>
    </mat-select>
    <div class="append">
        <i class="fa fa-spinner fa-spin" *ngIf="dept?.isLoading" ></i>
        <img *ngIf="!dept?.isLoading" src="../../../../../assets/images/icon_drop down.png">
    </div>
</div>